export default "__VITE_ASSET__c1d590b3__"